module.exports = __webpack_public_path__ + "static/media/infographicsMoreLikeThis.c2f38de2.svg";